import wxApi from '@/utils/wx_api'
import { UserLog } from '@/utils/log'
import getUserInfo from '@/common/utils/getUserInfo'

export default {
    methods: {
        openChat (e) {
            getUserInfo(e, () => {
                const { id } = e.target.dataset
                UserLog.contactConsultant(id)
                wx.navigateTo({
                    url: `/chat_list/chat/main?consultant_id=${id}&from=${this.from || ''}`
                })
            }, '需要认证用户信息才可以咨询置业顾问')
        }
    }
}